define.alias("shared/components/shared/ui/switcher", "settings/components/shared/ui/switcher");